export enum ConnectorModalType {
  ADD_ITEM = 'ADD_ITEM',
  REMOVE_ITEM = 'REMOVE_ITEM',
  CHANGE_QUANTITY = 'CHANGE_QUANTITY',
  EDIT_ITEM = 'EDIT_ITEM',
  APPLY_PROMO_CODE = 'APPLY_PROMO_CODE',
  REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE',
  APPLY_SUBSCRIPTION = 'APPLY_SUBSCRIPTION',
  QUOTE_CANCELLED = 'QUOTE_CANCELLED',
  LOGOUT = 'LOGOUT',
  NONE = 'NONE'
}

export enum ConnectorErrorType {
  NULLIFY_ERROR = 'NULLIFY_ERROR',
  GENERIC_ERROR = 'GENERIC_ERROR',
  CONFIGURATION_ERROR = 'CONFIGURATION_ERROR',
  NONE = 'NONE'
}

export interface ConnectorModalPayload {
  type: ConnectorModalType
  confirmCallback?: () => void
  cancelCallback?: () => void
}
